import { ColumnConfig, PrincipalProductColumnKey } from '../../model';

export const principalProductConfig: Record<
  PrincipalProductColumnKey,
  ColumnConfig
> = {
  productWithImage: {
    name: 'Product Title',
    field: 'component',
  },
  skuCode: {
    name: 'SKU Code',
    isHyperlink: true,
    headerExtra: {
      type: 'info',
      details:
        'A unique identification number for each product in any alphanumeric format.',
      title: 'SKU Code',
    },
  },
  productTitle: { name: 'Product Title', field: 'multiLine' },
  categories: { name: 'Categories', field: 'component' },
  scheme: { name: 'Scheme', alignment: 'center' },
  taxCategory: { name: 'Tax Category', alignment: 'center' },
  // pts: { name: 'PTS', sortField: 'price', alignment: 'flex-end' },
  ptr: { name: 'Price', alignment: 'flex-end' },
  marginPrice: { name: 'Price with Margin', alignment: 'flex-end' },
  packSize: { name: 'Pack Size', alignment: 'center' },
  status: { name: 'Status', alignment: 'center' },
  action: {
    name: 'Actions',
    alignment: 'center',
    field: 'component',
  },
};
